import { getFormattedDate } from '@mantine/dates';
import { formatMoney, TenantCurrency } from 'src/common/currency';

export const NOT_RECORDED = 'Not recorded';

export function textOrNotRecorded(value: unknown): string {
  if (value == null) return NOT_RECORDED;
  const text = String(value);
  return text.trim() === '' ? NOT_RECORDED : text;
}

export function truncatedTextOrNotRecorded(
  value: string | null | undefined,
  maxLength = 50,
): string {
  const text = textOrNotRecorded(value);
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}

export function dateOrNotRecorded(value: string | null | undefined): string {
  if (!value) return NOT_RECORDED;
  return getFormattedDate({
    type: 'default',
    date: new Date(value),
    locale: 'en',
    format: 'D MMMM YYYY',
    labelSeparator: '',
  });
}

export function moneyOrNotRecorded(
  amount: number | null | undefined,
  currency: TenantCurrency,
): string {
  return amount == null ? NOT_RECORDED : formatMoney(amount, currency);
}
